import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, message } from 'antd';

import { useAuth } from '../../../contexts/Auth';
import { Link as TypoLink } from '../../../components/DataView';

import { Container, Title, Wrapper } from './styles';
import Logo from '../../../assets/images/new_logo1.png';
import { AcessBlockedUserModal } from '../../../components/Modals/AcessBlockedUserModal';
import ReCAPTCHA from 'react-google-recaptcha';
import Recaptcha from '@/components/Recaptcha';

const LogIn: React.FC = () => {
    const { logIn, isLoading, data } = useAuth();
    const [form] = Form.useForm();
    const [showModalBlockedUser, setShowModalBlockedUser] = useState(false);
    const recaptchaRef = React.createRef<ReCAPTCHA>();

    const onSubmit = async () => {
        try {
            const values = form.getFieldsValue(true);
            const token = await recaptchaRef?.current?.executeAsync();
            if (!token) {
                message.error('Recaptcha Inválido');
                return;
            }
            logIn(values?.email, values?.password, token);
        } catch (err) {
            console.log(err);
            message.error('Ops! Algo deu errado. Tente novamente.');
        }
    };

    useEffect(() => {
        if (data?.error?.reason && data?.error?.date) {
            setShowModalBlockedUser(true);
        }
    }, [data?.error]);

    return (
        <>
            <Container>
                <Wrapper>
                    <Form form={form} onFinish={onSubmit}>
                        <Title>
                            <img src={Logo} alt="NeerHouse" />
                        </Title>
                        <Form.Item
                            name="email"
                            normalize={value=> typeof value==="string" ? value.trim(): value }
                            rules={[
                                {
                                    required: true,
                                    type: 'email',
                                    max: 255,
                                },
                            ]}
                        >
                            <Input
                                placeholder="Digite seu e-mail"
                                style={{ marginBottom: '2rem' }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor, insira a senha!',
                                },
                                { max: 255 },
                            ]}
                        >
                            <Input.Password
                                placeholder="Digite sua senha"
                                style={{ marginBottom: '3rem' }}
                            />
                        </Form.Item>
                        <Recaptcha ref={recaptchaRef} />
                        <Button
                            htmlType="submit"
                            style={{ marginBottom: '2rem' }}
                            className="default-btn"
                            loading={isLoading}
                        >
                            {isLoading ? 'Entrando...' : 'Entrar'}
                        </Button>
                        <Link to="/forgotpassword" component={TypoLink}>
                            Esqueceu a senha?
                        </Link>
                    </Form>
                </Wrapper>
            </Container>
            <AcessBlockedUserModal
                open={showModalBlockedUser}
                title="Seu usuário lojista está bloqueado"
                onCancel={() => setShowModalBlockedUser(false)}
                info={data?.error}
            />
        </>
    );
};

export default LogIn;
